<template>
  <Layout>
    <PageHeader :title="page.title" :items="page.items" />

    <!-- main -->
    <b-row>
      <b-col lg="12">
        <!-- 查询条件 -->
        <b-card>
          <b-row>
            <b-col lg="3">
              <b-form-group
                label="Scope Of Pushed"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="scope"
              >
                <b-form-select
                  v-model="search_condition.state"
                  :options="types.states"
                  value-field="value"
                  text-field="text"
                >
                </b-form-select>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group
                label="Status"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="status"
              >
                <b-form-select
                  v-model="search_condition.status"
                  :options="types.statuss"
                  value-field="value"
                  text-field="text"
                >
                </b-form-select>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-button variant="primary" @click="search()">Search</b-button>
            </b-col>
          </b-row>
        </b-card>

        <b-card>
          <!-- table -->
          <b-button v-has="'messagePushed::Create'" @click="gotoAdd" variant="primary"
            >Create</b-button
          >

          <div class="table-responsive mb-0">
            <b-table
              show-empty
              empty-text="no records"
              id="table"
              head-variant="light"
              ref="table"
              :busy="isBusy"
              :striped="true"
              :items="provider"
              :fields="fields"
              :per-page="search_condition.pageSize"
              :current-page="search_condition.pageNum"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-includedfields="filterOn"
              @filtered="onFiltered"
            >
              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>

              <template v-slot:cell(index)="data">
                {{
                  data.index +
                    (search_condition.pageNum - 1) * search_condition.pageSize +
                    1
                }}
              </template>
            </b-table>
          </div>
          <!-- end table -->
          <!-- pagination -->
          <b-row v-if="has_data">
            <b-col>
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination  mb-0" v-if="rows != 0">
                  <b-pagination
                    v-model="search_condition.pageNum"
                    :per-page="10"
                    :total-rows="rows"
                    aria-controls="table"
                  >
                  </b-pagination>
                </ul>
              </div>
            </b-col>
          </b-row>
          <!-- end pagination -->
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>
<script>
import DatePicker from "vue2-datepicker";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import timeZoneConversion from "@/components/widgets/timeZoneConversion";

/**
 * FAQ component
 */
export default {
  components: {
    Layout,
    PageHeader,
    DatePicker,
  },
  data() {
    return {
      page: {
        title: "Message Pushed",
        items: [
          {
            text: "UNI-CORE",
            // href: "/"
          },
          {
            text: "Marketing Manage",
            // href: "/"
          },
          {
            text: "Message Pushed",
            active: true,
          },
        ],
      },
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      fields: [
        { key: "index", label: "#", class: "text-center" },
        { key: "title", label: "Push The Title", class: "text-center" },

        {
          key: "state",
          label: "Scope Of Pushed",
          class: "text-center",
          formatter: (value) => {
            let a = ""
            this.types.states.forEach(item=>{
              if(item.value==value){
                a = item.text
              }
            })
            return a;
          },
        },
        {
          key: "status",
          label: "Status",
          formatter: (value) => {
            let a = ""
            this.types.statuss.forEach(item=>{
              if(item.value==value){
                a = item.text
              }
            })
            return a;
          },
          class: "text-center",
        },
        { key: "operatorName", label: "Operator", class: "text-center" },
        {
          key: "createTime",
          label: "Create Time",
          class: "text-center",
          formatter: (value) => {
            if (value) {
              return timeZoneConversion.getLocalTime(value);
            } else {
              return "";
            }
          },
        },
        { key: "remarks", label: "Notes", class: "text-center" },
      ],
      search_condition: {
        pageNum: 1,
        pageSize: 10,
        state: "",
        status: "",
      },
      isBusy: false,
      has_data: false,
      types: {
        states: [
          { text: "Please select", value: "", disabled: false },
          { text: "All users", value: 0, disabled: false },
          { text: "Specify a user", value: 1, disabled: false },
        ],
        statuss: [
          { text: "Please select", value: "", disabled: false },
          { text: "To push", value: 0, disabled: false },
          { text: "Have to push", value: 1, disabled: false },
          { text: "Failed to push", value: 2, disabled: false },
        ],
      },
    };
  },
  computed: {
    rows() {
      return this.totalRows;
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    gotoAdd() {
      this.$router.push("messagePushedAdd");
    },
    provider(ctx) {
      this.isBusy = true;
      return this.$api.marketingManage.list(this.search_condition, ctx)
        .then((x) => {
          this.isBusy = false;
          if (x.total) {
            this.has_data = true;
            this.totalRows = x.total;
            return x.data;
          } else {
            this.has_data = false;
            return [];
          }
        })
        .catch((e) => {
          this.isBusy = false;
          this.has_data = false;
          return [];
        });
    },
    search() {
      this.search_condition.pageNum = 1;
      this.$refs.table.refresh();
    },
  },
};
</script>
